export const EMPTY_NODE = '__EMPTY__'
export const LOADING_NODE = '__LOADING__'
